<template>
    <div class="size-full rounded-lg border flex flex-col justify-between p-[12px]">
        <div class="w-full"><h2 class="flex items-center gap-x-2">Contrats par type <Info :size="15" strokeWidth="1.3"/></h2></div>
         <div class="mx-auto h-[180px] w-[95%]">
            <apexchart type="donut" :options="options" :series="series"></apexchart>
         </div>
        <div class="flex items-center justify-between">
                <div class="flex items-center gap-x-2">
                    <div  class="size-5 rounded-md bg-[#3474f4]"/>
                    <span class="font-extralight">CDI</span>
                </div>
                <div class="flex items-center  gap-x-2">
                    <div  class="size-5 rounded-md bg-[#fa9832]"/>
                    <span class="font-extralight">CDD</span>
                </div>
                <div class="flex items-center gap-x-2">
                    <div class="size-5 rounded-md bg-[#24ae75]"/>
                    <span class="font-extralight">STAGIAIRE</span>
                </div>
                <div class="flex items-center gap-x-2">
                    <div class="size-5 rounded-md bg-[#ee4636]"/>
                    <span class="font-extralight">CONSULTANT</span>
                </div>
        </div>
    </div>
</template>
<script>
import {Info} from "lucide-vue-next"
export default {
    name: "ContratType",
    components:{
        Info
    },
    props:['serie'],
    mounted(){
        this.series = this.serie;
    },
    data(){
        return {
            series: [],
            options:{
                chart: {
                    type: 'donut',
                    toolbar: {
                        show: false
                    },
                },
                stroke: {
                    width: 6,
                },
                labels: ['CDI', 'CDD', 'STAGIAIRE', 'CONSULTANT'],
                colors: ['#3474f4', '#fa9832','#24ae75','#ee4636'],
                plotOptions:{
                    pie:{
                        startAngle: -90,
                        endAngle: 90,
                        offsetY: 10,
                        donut:{
                            size: '55%',
                        },
                    }
                },
                dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                },
            }
        }
    },
}
</script>